import { render, staticRenderFns } from "./NodeClick.vue?vue&type=template&id=22ef344e&"
import script from "./NodeClick.vue?vue&type=script&lang=js&"
export * from "./NodeClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports